import styled from 'styled-components';

export default styled.span`
  font: bold 0.75rem sans-serif;
  margin-left: 0.5rem;
`;
